import { render, staticRenderFns } from "./JobboardIcon.vue?vue&type=template&id=40acf1d8&"
import script from "./JobboardIcon.vue?vue&type=script&lang=js&"
export * from "./JobboardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports